"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeFromLanguage = void 0;
var SUPPORTED_LOCALES = ['en', 'es'];
var getSupportedLocales = function () {
    var _a;
    var locales = ((_a = process.env.SUPPORTED_LOCALES) !== null && _a !== void 0 ? _a : '').split(',');
    return locales.length > 0 ? locales : SUPPORTED_LOCALES;
};
var localeFromLanguage = function (language) {
    var supported = getSupportedLocales();
    var locale = (language || '').split('-')[0];
    return supported.includes(locale) ? locale : supported[0];
};
exports.localeFromLanguage = localeFromLanguage;
